import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_get_work_class_assignmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workClassId: number }): 
  Promise<{ result: { WorkClassId?: number, UserId?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workClassId)) {
      missingRequiredInParams.push('\'workClassId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_class_assignments/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { workClassId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { WorkClassId?: number, UserId?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workClassId)) {
      missingRequiredInParams.push('\'workClassId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_class_assignments/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { workClassId: number, $keys: { WorkClassId?: number, UserId?: string }[] }): 
  Promise<{ result: { WorkClassId?: number, UserId?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workClassId)) {
      missingRequiredInParams.push('\'workClassId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_class_assignments/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workClassId: number    }) {
        if(isNil(inParams.workClassId)) {
          return true; 
        }
      return false;
    }
}
